// @flow
import React from 'react';
import {
  useCustomValidation,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import { RowContext } from '../grid.js';
import {
  types as t,
  type CompilerInjectedProps,
} from '../validation/runtime-checks/index.js';
import Figure from '../Figure.js';
import { InternalBunnyVideo } from '../InternalBunnyVideo.js';
import { useValidateBunnyVideoInLibrary } from '../useValidateBunnyVideoInLibrary.js';

const width = 596;
const height = 360;

export default function PTNBunnyVideo(props: {|
  videoId: string,
  ...CompilerInjectedProps,
|}) {
  const { failedValidation, addErrors, locations } = usePropsValidation(
    props,
    PTNBunnyVideo,
  );
  const { pixelWidth } = React.useContext(RowContext);

  const { failedValidation: failedCustomValidation } = useCustomValidation(
    props,
    (addErrors, locations) => {
      if (width != null && width > pixelWidth)
        addErrors([
          {
            message: `Videos should have at least ${width}px wide containers. Container width: ${pixelWidth}`,
            ...locations.PTNBunnyVideo,
          },
        ]);
    },
  );

  useValidateBunnyVideoInLibrary({
    performValidation: props._performValidation,
    failedValidation,
    addErrors,
    location: locations.videoId,
    videoId: props.videoId,
  });

  if (failedValidation || failedCustomValidation) return null;
  return (
    <Figure>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <InternalBunnyVideo
          videoId={props.videoId}
          width={width}
          height={height}
          borderRadius={8}
        />
      </div>
    </Figure>
  );
}
PTNBunnyVideo.spec = {
  videoId: t.string,
};
